import { render, staticRenderFns } from "./ModalOtherIncomeNew.vue?vue&type=template&id=50809434&"
import script from "./ModalOtherIncomeNew.vue?vue&type=script&lang=js&"
export * from "./ModalOtherIncomeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports